import { useState } from 'react';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="nav-container">
        <a href="#home" className="logo" onClick={closeMenu}>
          <span className="logo-mark" aria-hidden="true">BF</span>
          <span className="logo-copy">
            <small>The</small>
            Bright Future
          </span>
        </a>

        <nav aria-label="Main navigation">
          <ul className={`nav-links${menuOpen ? ' active' : ''}`} id="navLinks">
            <li><a href="#home" onClick={closeMenu}>Home</a></li>
            <li><a href="#courses" onClick={closeMenu}>Courses</a></li>
            <li><a href="#gallery" onClick={closeMenu}>Gallery</a></li>
            <li><a href="#knowledge" onClick={closeMenu}>Learn</a></li>
            <li><a href="#health-guide" onClick={closeMenu}>Health Guide</a></li>
            <li><a href="#about" onClick={closeMenu}>About</a></li>
            <li><a href="#director" onClick={closeMenu}>Director</a></li>
            <li><a href="#features" onClick={closeMenu}>Why us</a></li>
            <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
            <li className="nav-cta">
              <a
                href="https://wa.me/919242912480?text=Hi%20I'm%20interested%20in%20your%20courses!"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                onClick={closeMenu}
              >
                Book a free trial
              </a>
            </li>
          </ul>
        </nav>

        <button
          className={`hamburger${menuOpen ? ' active' : ''}`}
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
          aria-controls="navLinks"
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
